import { styled } from '@mui/material';

import { popoverContentFooterClasses } from './theme';

import type { PopoverContentFooterProps } from './types';

const PopoverContentFooter = (props: PopoverContentFooterProps) => {
  const { buttons } = props;

  if (!buttons || !buttons.length) return null;

  return (
    <PopoverContentFooterRoot>
      <PopoverContentFooterButtons>{buttons.map(button => button)}</PopoverContentFooterButtons>
    </PopoverContentFooterRoot>
  );
};

const PopoverContentFooterRoot = styled('div', {
  target: popoverContentFooterClasses.root,
})`
  * + & {
    margin-top: 8px;
  }
`;

const PopoverContentFooterButtons = styled('div', {
  target: popoverContentFooterClasses.buttons,
})`
  & > * + * {
    margin-left: 8px;
  }
`;

export default PopoverContentFooter;
